import { defaultTo, orderBy } from "lodash";
import { DateTime } from "luxon";
import { VisitSalesItemPublicModel } from './VisitSalesItemPublicModel';
import { IVisitSalesItemAttributeModel, IVisitSalesItemPublicModel, VisitSalesItemAttributeModel, VisitSalesItemTraitListingModel, IVisitSalesItemTraitListingModel } from ".";
import { DiscountItemTypes } from "./Enums";

export interface IVisitSalesItemModel extends IVisitSalesItemPublicModel {
    isInPackage: boolean;
    /*
    isPackageAddOn: boolean;    
    */
    salesItemId: number;
    salesItemOptionId: number;
    salesPlanId: number | undefined;
    salesPlanName: string | undefined;

    salesItemSalesItemTypeId: number;
    salesItemSalesItemTypeName: string;
    salesItemCommunicationTypeId: number | null;
    salesItemReminderDays: number | null;
    dueDate?: string | undefined;
    /*
    salesItemSalesCategoryId: number;
    salesItemSalesCategoryName: string;
    salesItemSalesSubCategoryId: number;
    salesItemSalesSubCategoryName: string;
    
    
    /*
    salesItemDiscountTypeId: number;
    salesItemDiscountTypeName: string;
    salesItemIsAutomaticallyGiven: boolean;
    salesItemIsRabiesVaccination: boolean;
    
    salesItemCommunicationTypeName: string;
    
    salesItemSupplierProductName: string;
    */
    salesItemSupplierProductCode: string;
    visitId: number;
    /*
    reminderResetByVisitSalesItemId: number | null;
    pendedResetByVisitSalesItemId: number | null;
    */
    visitSalesItemId: number;
    /*
    prescriptionLabelId: number | null;
    salesItemOptionRefills: number | null;
    salesItemOptionPackageQuantity: number | null;
    */
    parentVisitSalesItemId: number | undefined;
    /*
    salesItemAutoAddToVisitTypeId: number;
    salesItemAutoAddToVisitTypeName: string;
    */
    visitSalesItemAttributes: IVisitSalesItemAttributeModel[];
    salesItemOptionBusinessLineSKU: string | undefined;
    salesItemOptionPetcoSKU: string | undefined;
    salesItemOptionUnitOfMeasureQuantity: number | undefined;
    salesItemOptionUnitOfMeasureId: number | undefined;
    salesItemOptionUnitOfMeasureName: string | undefined;
    visitSalesItemTraits: IVisitSalesItemTraitListingModel[];
    /*
    salesItemOptionAdditionalInfoLabelId: number | null;
    salesItemOptionAdditionalInfoLabel: string;
    diagnosticResultsRawData: string;
    includeInDrugLog: boolean;
    prescriptionFulfillmentId: number | null;
    prescriptionFulfillmentPackageItemCount: number | null;
    prescriptionFulfillmentPackageRefillDays: number | null;
    prescriptionFulfillmentPackagesSold: number | null;
    prescriptionFulfillmentPackagesForYear: number | null;
    prescriptionFulfillmentPackagesSoldRefillDays: number | null;
    prescriptionVisitSalesItemId: number | null;    
    salesItemOptionPrescriptionLabelName: string;
    salesItemOptionPrescriptionLabelInstructions: string;
    // prescription: PrescriptionModel;
    attributeHTML: string;
    attributeText: string;
    diagnosticHTML: string;
    */
}

export class VisitSalesItemModel extends VisitSalesItemPublicModel implements IVisitSalesItemModel {// Record<keyof IVisitSalesItemModel, any> {
    visitId: number;
    visitSalesItemId: number;
    salesItemId: number;
    salesItemOptionId: number;
    visitSalesItemAttributes: VisitSalesItemAttributeModel[];
    parentVisitSalesItemId: number | undefined
    salesItemOptionBusinessLineSKU: string | undefined
    attributeElements: (string | JSX.Element | JSX.Element[])[]
    isInPackage: boolean;
    salesPlanId: number | undefined;
    salesPlanName: string | undefined;
    salesItemSalesItemTypeId: number;
    salesItemSalesItemTypeName: string;
    salesItemCommunicationTypeId: number | null;
    salesItemOptionPetcoSKU: string | undefined;
    salesItemOptionUnitOfMeasureQuantity: number | undefined;
    salesItemOptionUnitOfMeasureId: number | undefined;
    salesItemOptionUnitOfMeasureName: string | undefined;
    salesItemSupplierProductCode: string;
    visitSalesItemTraits: VisitSalesItemTraitListingModel[];
    salesItemReminderDays: number | null;
    dueDate?: string | undefined;

    constructor(params: IVisitSalesItemModel, visitDate?: DateTime | undefined) {
        super(params);
        this.visitId = defaultTo(params.visitId, 0);
        this.visitSalesItemId = defaultTo(params.visitSalesItemId, 0);
        this.salesItemId = defaultTo(params.salesItemId, 0);
        this.salesItemOptionId = defaultTo(params.salesItemOptionId, 0);
        this.salesItemSalesItemTypeId = defaultTo(params.salesItemSalesItemTypeId, 0);
        this.parentVisitSalesItemId = params.parentVisitSalesItemId;
        this.salesItemOptionBusinessLineSKU = params.salesItemOptionBusinessLineSKU;
        this.salesItemOptionPetcoSKU = defaultTo(params.salesItemOptionPetcoSKU, "");
        this.salesItemOptionUnitOfMeasureQuantity = params.salesItemOptionUnitOfMeasureQuantity;
        this.salesItemOptionUnitOfMeasureId = params.salesItemOptionUnitOfMeasureId;
        this.salesItemOptionUnitOfMeasureName = defaultTo(params.salesItemOptionUnitOfMeasureName, "");
        this.salesItemCommunicationTypeId = defaultTo(params.salesItemCommunicationTypeId, 0);
        this.salesItemSalesItemTypeName = defaultTo(params.salesItemSalesItemTypeName, "");
        this.visitSalesItemAttributes = orderBy(params.visitSalesItemAttributes ?? [], "sortOrder").map(vsa => new VisitSalesItemAttributeModel(vsa, visitDate, this.quantity, this.salesItemOptionUnitOfMeasureName, this.salesItemCommunicationTypeId!))
        this.isInPackage = defaultTo(params.isInPackage, false)
        this.salesPackageName = params.salesPackageName
        this.salesPlanId = params.salesPlanId;
        this.salesPlanName = params.salesPlanName;
        this.attributeElements = VisitSalesItemAttributeModel.parseAttributeElements(this.visitSalesItemAttributes);
        this.salesItemSalesItemTypeId = defaultTo(params.salesItemSalesItemTypeId, 0);
        this.salesItemSupplierProductCode = params.salesItemSupplierProductCode;
        this.visitSalesItemTraits = (params.visitSalesItemTraits ?? []).map(vsit => new VisitSalesItemTraitListingModel(vsit));
        this.salesItemReminderDays = params.salesItemReminderDays;
        this.dueDate = defaultTo(params.dueDate, !_.isNil(params.salesItemReminderDays) && !_.isNil(visitDate)? visitDate.plus({ days: params.salesItemReminderDays! }).toISO():undefined);
    }

    IsDiscountItem = () => DiscountItemTypes.includes(this.salesItemSalesItemTypeId);
}
